<!--
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-06-24 13:51:27
 * @LastEditors: hongye
 * @LastEditTime: 2025-12-17 16:12:30
-->
<template>
  <Select
    v-model:value="state.value"
    show-search
    :placeholder="$lang('请输入站点名称/编号查询')"
    style="width: 100%"
    :filter-option="false"
    :not-found-content="state.fetching ? undefined : null"
    :options="state.data"
    @search="fetchUser"
    @change="changeCode"
    allowClear
  >
    <template v-if="state.fetching" #notFoundContent>
      <spin size="small" />
    </template>
  </Select>
</template>
<script lang="ts" setup>
  import { reactive, toRef, watch } from 'vue'
  import { Select, Spin } from 'ant-design-vue'
  import { debounce } from 'lodash-es'
  import { siteService } from '@/service/api'
  interface Props {
    searchParam?: any
    item?: any
    stationType?: any
    reqUrl?: string
    params?: any
    optionData?: Array<any>
    showKey?: boolean
  }
  const props = withDefaults(defineProps<Props>(), {
    showKey: true
  })

  const state = reactive({
    data: [] as Array<any>,
    value: '',
    fetching: false
  })
  const fetchUser = debounce((value) => {
    if (!value) return
    if (props.reqUrl && value.length < 2) return
    state.data = []
    state.fetching = true
    siteService[props.reqUrl ? props.reqUrl : 'dimStation']({
      param: value,
      ...props.params,
      stationType: props.stationType
    }).then((res) => {
      state.fetching = false
      if (res.code === 1) {
        state.data = res.data.map((_: any) => {
          return {
            label: props.showKey ? `${_.value} | ${_.key}` : `${_.value}`,
            value: _.key
          }
        })
      }
    })
  }, 300)

  const changeCode = (value: any) => {
    props.searchParam[props.item.prop] = value
  }
  watch(() => props.searchParam[props.item.prop], (value) => {
    state.value = value
  })

  watch(toRef(state.value), () => {
    state.data = []
  })
  watch(() => props.optionData, (data) => {
    state.data = data || []
  })
</script>
